import { Stack, Typography } from '@mui/material';
import { PriceTypes } from '@/models/catalog/course';
import type { Installment } from '@/models/catalog/offer';
import { calculateInstallmentValue } from '@/packages/courses/components/prices/utils';
import { formatMoney } from '@/utils/format-money';

interface MainPriceProps {
  salePrice: number | null;
  isIncluded: boolean;
  installment: Installment | null;
  type: PriceTypes;
}

export const MainPrice = ({
  salePrice,
  isIncluded,
  installment,
  type,
}: MainPriceProps) => {
  if (salePrice === null) {
    return (
      <Typography variant="h2" color="primary.dark">
        Preço sob consulta
      </Typography>
    );
  }

  if (isIncluded) {
    return (
      <Typography variant="h2" color="primary.dark">
        Curso incluso
      </Typography>
    );
  }

  return (
    <Stack spacing={0.5} direction="row" alignItems="baseline">
      {installment && salePrice > 0 && (
        <Typography color="primary.dark">{installment.max}x</Typography>
      )}
      <Typography variant="h1" color="primary.dark">
        {installment
          ? formatMoney(calculateInstallmentValue(salePrice, installment))
          : formatMoney(salePrice)}
      </Typography>
      {type === PriceTypes.Tuition && (
        <Typography component="span" color="primary.dark">
          /Mês
        </Typography>
      )}
      {installment && (installment.fee ?? 0) > 0 && (
        <Typography component="span" color="primary.dark">
          com juros
        </Typography>
      )}
    </Stack>
  );
};
